import uz_UZ from "json-loader!yaml-loader!./uz-UZ.yml";
import uz_CYR from "json-loader!yaml-loader!./uz-CYR.yml";
import uz_QR from "json-loader!yaml-loader!./uz-QR.yml";
import ru_RU from "json-loader!yaml-loader!./ru-RU.yml";
import en_US from "json-loader!yaml-loader!./en-US.yml";

import enLocale from "element-ui/lib/locale/lang/en";
import ruLocale from "element-ui/lib/locale/lang/ru-RU";

export default {
  locales: [
    { code: "uz-UZ", title: "O'zbekcha" },
    { code: "uz-CYR", title: "Ўзбекча" },
    { code: "uz-QR", title: "Qaraqalpaqsha" },
    { code: "ru-RU", title: "Русский" },
    { code: "en-US", title: "English" }
  ],
  messages: {
      "uz-UZ": Object.assign(uz_UZ, ruLocale),
      "uz-CYR": Object.assign(uz_CYR, ruLocale),
      "uz-QR": Object.assign(uz_QR, ruLocale),
      "ru-RU": Object.assign(ru_RU, ruLocale),
      "en-US": Object.assign(en_US, enLocale)
  }
};
